import React, { useCallback, useState } from 'react';
import { Button, Form, Input, Tooltip, message } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';

function HomeTileRecordId({
  id,
  onlyButton = false,
  isDeepLink = false,
}: {
  id: string | undefined;
  onlyButton?: boolean;
  isDeepLink?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  const title = isDeepLink ? 'Copy deep link' : 'Copy title ID';
  const messageSuccess = isDeepLink ? 'Copied deep link to the clipboard!' : 'Copied tile id to the clipboard!';

  const handleCopyToClipboard = useCallback(() => {
    setCopied(true);
    const input = document.createElement('input');
    input.setAttribute('value', id!);
    document.body.appendChild(input);
    input.select();
    // document.execCommand('copy');
    navigator.clipboard.writeText(id!);
    document.body.removeChild(input);

    message.success(messageSuccess).then(r => r);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }, [id]);

  if (onlyButton) {
    return (
      <Tooltip title={title}>
        <Button
          onClick={handleCopyToClipboard}
          icon={copied ? <CheckOutlined /> : <CopyOutlined />}
          style={{ color: copied ? 'green' : 'black' }}
        />
      </Tooltip>
    );
  }

  return (
    <Form.Item name={!isDeepLink ? 'id' : undefined} label={isDeepLink ? 'Deep link' : 'ID'}>
      <Input.Group compact>
        <Input readOnly style={{ width: 'calc(100% - 34px)' }} value={id} />
        <Tooltip title={title}>
          <Button
            onClick={handleCopyToClipboard}
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            style={{ height: 36, color: copied ? 'green' : 'black' }}
          />
        </Tooltip>
      </Input.Group>
    </Form.Item>
  );
}

export default HomeTileRecordId;
